import { debounce } from 'tiny-throttle';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import { getAddToCartSelectors, filterCheckoutForms } from '../domUtils';
import { logError, logInfo } from '../../shared/utils/logging';
import CloningButtonsUtilsBase from '../cloningButtonsUtilsBase';

export default class CandyRackCloningButtonsUtils extends CloningButtonsUtilsBase {
  debouncedCloneButtons: Function | undefined;

  constructor(eventName: string) {
    super(eventName, REGISTERED_APPS.ADD_TO_CART);

    // letting debouncedCloneButtons definition as is, to minimize risk during the refactoring.
    // We can move it at a later point to the superclass at later point, sharing the code between
    // the subclasses
    this.debouncedCloneButtons = debounce(this.cloneButtons.bind(this), 1000);
    window.CRcloneButtons = this.debouncedCloneButtons;
    logInfo('loaded buttons', REGISTERED_APPS.ADD_TO_CART);
  }

  getButtons(): HTMLInputElement[] {
    return Array.from(
      new Set(
        Array.from(
          document.querySelectorAll<HTMLInputElement>(getAddToCartSelectors()),
        ),
      ),
    )
      .filter(filterCheckoutForms)
      .filter(
        (element) =>
          !this.buttonPairs.find(
            (pair) =>
              pair.hiddenButton === element || pair.clonedButton === element,
          ),
      );
  }

  buttonWatcher() {
    try {
      const observer = new MutationObserver(() => {
        if (this.debouncedCloneButtons) {
          this.debouncedCloneButtons(REGISTERED_APPS.ADD_TO_CART);
        }
      });
      const targetNode = document.body;
      observer.observe(targetNode, { childList: true });
    } catch (error) {
      logError(
        'Failed to setup ATC observer',
        REGISTERED_APPS.ADD_TO_CART,
        error,
      );
    }
  }
}
